import OrderShipmentDeliveryDateStrategy from '@/domain/OrderShipmentDeliveryDateStrategy'

export const FromOrderExpireDate = new OrderShipmentDeliveryDateStrategy(0, 'Из даты истечения заказа')
export const ExecutorDetermineDate = new OrderShipmentDeliveryDateStrategy(1, 'Определяет поставщик')
